/**
 * Route space helpers: classify paths as admin vs user space
 * for redirects when ACT (dashboard context) changes.
 */

/** Path prefix that marks admin-only pages (locale may be in path, e.g. /en/admin/... or /admin/...) */
const ADMIN_PATH_PREFIX = '/admin';

/**
 * Returns true if the current pathname is in admin space (admin-only pages).
 * When user switches ACT from Admin to Private/Org, we redirect them off these pages.
 */
export function isAdminPath(pathname: string | null | undefined): boolean {
  if (!pathname || typeof pathname !== 'string') return false;
  return pathname.includes(ADMIN_PATH_PREFIX);
}
